import { memo } from 'react';
import { useGetSelectionInstrumentIds } from 'shared-modules/hooks/select';
import PropTypes from 'prop-types';
import { Spin } from '../../../../../components';
import styles from './header.module.scss';
import { CardHeader } from '../../CardHeader/index';

export const Header = memo(({ strategyGroup, loadingSelections }) => {
  const {
    image,
    serviceId,
    name,
    labId,
    attribute,
    featureNames,
    simulationStats: { selectionStrategyDetailList },
    strategyList,
    externalLinkUrl,
    externalLinkName,
  } = strategyGroup;
  const { isRangeOut } = attribute ?? {};
  const isShare = labId != null;
  const validExternalLink = Boolean(externalLinkUrl && externalLinkName);

  const instrumentIds = useGetSelectionInstrumentIds({ isShare, strategyList, selectionStrategyDetailList });

  if (loadingSelections) {
    return <Spin className={styles.loader} />;
  }

  return (
    <div className={styles.container}>
      <CardHeader
        image={image}
        name={name}
        serviceId={serviceId}
        featureNames={featureNames}
        instrumentIds={instrumentIds}
        isRangeOut={isRangeOut}
        isShare={isShare}
        isRangeOutMessageNeeded
        externalLinkUrl={validExternalLink ? externalLinkUrl : null}
        tagContainerStyle={styles.cardHeaderTagContainer}
      />
    </div>
  );
});

Header.propTypes = {
  strategyGroup: PropTypes.shape({
    image: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]).isRequired,
    serviceId: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    comment: PropTypes.string,
    labId: PropTypes.number,
    attribute: PropTypes.shape({
      closeTradeCount: PropTypes.number,
      isRangeOut: PropTypes.bool,
    }),
    featureNames: PropTypes.arrayOf(PropTypes.string),
    simulationStats: PropTypes.shape({
      selectionStrategyDetailList: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    strategyList: PropTypes.arrayOf(PropTypes.shape({})),
    externalLinkUrl: PropTypes.string,
    externalLinkName: PropTypes.string,
  }),
  loadingSelections: PropTypes.bool,
};

Header.defaultProps = {
  strategyGroup: undefined,
  loadingSelections: false,
};
